import { render, staticRenderFns } from "./MessageSendOption.vue?vue&type=template&id=bcb64818"
import script from "./MessageSendOption.vue?vue&type=script&lang=js"
export * from "./MessageSendOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports